module.exports = __webpack_public_path__ + "img/renlizhaopin.4e5d09c1.png";